import React from 'react';
import { Box, Typography, Card, Stack, Button } from '@mui/material';

export default function ProductItem({
  canRemove,
  onRemoveProduct,
  onItemPress,
  title,
  imageUrl,
  amount,
  discount,
  showDiscount,
}) {
  return (
    <Card sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Stack sx={{ width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
        <Box overflow={'hidden'} width={'100%'}>
          <img
            src={imageUrl}
            width={'100%'}
            height={'130px'}
            alt={'logo'}
            onError={(event) => {
              if (title?.toLowerCase()?.includes('mtn')) {
                event.target.src =
                  'https://firebasestorage.googleapis.com/v0/b/imageupload-e4f08.appspot.com/o/icons%2Fmtn.png?alt=media&token=a22528a2-e6aa-4ec5-b0fd-d930e2b3b1a0';
              }
              if (title?.toLowerCase()?.includes('airtel')) {
                event.target.src =
                  'https://firebasestorage.googleapis.com/v0/b/imageupload-e4f08.appspot.com/o/icons%2Fairtel.png?alt=media&token=96e584dc-20bc-4527-81dc-61cc6f49bdd9';
              }
              if (title?.toLowerCase()?.includes('glo')) {
                event.target.src =
                  'https://firebasestorage.googleapis.com/v0/b/imageupload-e4f08.appspot.com/o/icons%2Fglo.png?alt=media&token=5f8ec29f-e5f7-49fc-b57d-d50dcf116cec';
              }
              if (title?.toLowerCase()?.includes('9mobile')) {
                event.target.src =
                  'https://firebasestorage.googleapis.com/v0/b/imageupload-e4f08.appspot.com/o/icons%2Fetisalat.png?alt=media&token=8f0d6145-33d6-45fa-9114-ca0338b60fc1';
              }
              event.onerror = null;
            }}
          />
        </Box>
        <Typography fontSize={'14px'} textAlign={'center'} mt={1}>
          {title}
        </Typography>
        <Typography>{showDiscount ? `%${discount || '0.0'} Discount` : `₦${amount}`}</Typography>
        <Stack padding={1} width={'100%'} spacing={1}>
          <Button onClick={onItemPress} variant="outlined" fullWidth>
            Update
          </Button>
          {canRemove && (
            <Button onClick={onRemoveProduct} variant="outlined" fullWidth color={'error'}>
              Remove
            </Button>
          )}
        </Stack>
      </Stack>
    </Card>
  );
}
